import {FC} from 'react';
import clsx from 'clsx';

import s from '../styles.module.scss';

interface RemovalRequestHeaderProps {
  siteName: string;
  isFullHD: boolean;
}

export const RemovalRequestHeader: FC<RemovalRequestHeaderProps> = ({siteName, isFullHD}) => (
  <div
    className={clsx(s['removal-request-header'], {[s['removal-request-header--fhd']]: isFullHD})}
  >
    <p className={s['removal-request-header__p']}>
      {siteName} is a powerful search engine with results across the internet. Our data is collected
      via automated processes.
    </p>

    <p className={s['removal-request-header__strong']}>
      We process removal requests of the following types:
    </p>

    <ul className={s['removal-request-header__list']}>
      <li>
        Requests from copyright owners claiming infringement of protected works with a legally
        sufficient notice.
      </li>
      <li>
        Requests from governments and legal authorities (submitted from an official email address so
        we can verify the authority of the requesting party).
      </li>
    </ul>

    <p className={s['removal-request-header__p']}>
      Requests are assessed on an individual basis and the validity is at the discretion of{' '}
      {siteName}.
    </p>
  </div>
);
